/* eslint-disable */
import { FormControl, FormHelperText, makeStyles, MenuItem, Select, SelectProps } from "@material-ui/core";
import React from "react";
const classStyle = makeStyles(theme => ({
    fieldInput: {
        "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0000 !important",
            borderWidth: "1px !important",
        },
        '&.Mui-error .MuiOutlinedInput-notchedOutline':{
            borderColor: "red !important",
            borderWidth: 1,
        }
    },
    paperClass: {
        "& .MuiList-root.MuiMenu-list": {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            maxWidth: 300,
        },
        "& .MuiButtonBase-root.MuiListItem-root": {
            width: 100 / 3 + "%",
            display: "flex",
            justifyContent: "center",
            borderRadius: 2
        },
        "& .MuiListItem-root.Mui-selected": {
            backgroundColor:"#00B0E1",
            color:"#ffffff"
        },
    },
}));


export default function SelectDays({ error, helperText, containerClass, onChange, value, name }) {
    const classes = classStyle();
    return (
        <FormControl fullWidth size="small">
            <Select
                multiple
                variant="outlined"
                className={`${classes.fieldInput} ${containerClass}`}
                error={error}
                name={name}
                value={value}
                onChange={onChange}
                MenuProps={{
                    PaperProps: {
                        className: `${classes.paperClass}`,
                    },
                    anchorOrigin: { vertical: "bottom", horizontal: "left", },
                    getContentAnchorEl: null,
                }}>
                {[
                    { title: "จันทร์", value: "จ" },
                    { title: "อังคาร", value: "อ" },
                    { title: "พุธ", value: "พ" },
                    { title: "พฤหัสบดี", value: "พฤ" },
                    { title: "ศุกร์", value: "ศ" },
                    { title: "เสาร์", value: "ส" },
                    { title: "อาทิตย์", value: "อา" },
                ].map((item, idx) => (
                    <MenuItem key={`days_${idx}`} value={item?.value}>
                        {item?.title}
                    </MenuItem>
                ))}
            </Select>
            {Boolean(helperText) && <FormHelperText className="text-danger position-absolute m-0" style={{bottom:-23}}>{helperText}</FormHelperText>}
        </FormControl>
    );
}
